module.exports = __webpack_public_path__ + "static/media/iitpallakad.f872c33c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/iitpallakad.svg
// module id = 72
// module chunks = 1